import { Controller } from "@hotwired/stimulus"
import { AVCrypto } from "@assemblyvoting/av-crypto";

// Connects to data-controller="election-committee-member-keys"
export default class extends Controller {
  declare passwordFieldTarget: HTMLInputElement;
  declare passwordConfirmationFieldTarget: HTMLInputElement;
  declare publicKeyFieldTarget: HTMLInputElement;
  declare submitButtonTarget: HTMLButtonElement;
  static targets = [
    "passwordField",
    "passwordConfirmationField",
    "publicKeyField",
    "submitButton",
  ]

  static values = {
    salt: String,
    curveName: String,
  }
  declare saltValue: string;
  declare curveNameValue: string;

  connect() {
    this.element.addEventListener("submit", (event: Event) => this.onSubmit(event as SubmitEvent));
    this.passwordFieldTarget.disabled = false;
    this.passwordConfirmationFieldTarget.disabled = false;
  }

  onSubmit(event: SubmitEvent) {
    const password = this.passwordFieldTarget.value;
    const passwordConfirmation = this.passwordConfirmationFieldTarget.value;

    setTimeout(() => {
      this.submitButtonTarget.disabled = false;
    }, 2000);

    if (!password) {
      this.passwordFieldTarget.classList.toggle("is-invalid", true)
      event.preventDefault();
      return;
    }

    if (password !== passwordConfirmation) {
      this.passwordConfirmationFieldTarget.classList.toggle("is-invalid", true)
      event.preventDefault();
      return;
    }

    this.passwordFieldTarget.disabled = true;
    this.passwordConfirmationFieldTarget.disabled = true;

    const crypto = new AVCrypto(this.curveNameValue);
    const { publicKey } = crypto.generateProofOfElectionCodes([`${this.saltValue}${password}`]);
    this.publicKeyFieldTarget.value = publicKey;
  }
}
